import { colors } from "../const";

/*
 * The pill buttons the navbar uses for "Login" / "Download app" / "Become a
 * partner". They started out inside the navbar style sheet but the About page
 * reuses them for its board-members toggle, so they live here instead.
 */
export const outlinedButton = {
  color: colors.blue,
  border: `1px solid ${colors.blue}`,
  backgroundColor: colors.white,
  borderRadius: "8px",
  textTransform: "initial",
  fontSize: "14px",
  "&:hover": {
    border: `1px solid ${colors.blue}`,
  },
};

export const containedButton = {
  color: colors.white,
  border: `1px solid ${colors.blue}`,
  backgroundColor: colors.blue,
  borderRadius: "8px",
  textTransform: "initial",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: colors.blue,
    color: colors.white,
  },
};
